import { render, staticRenderFns } from "./projectCase.vue?vue&type=template&id=bd05d70e&scoped=true&"
import script from "./projectCase.vue?vue&type=script&lang=js&"
export * from "./projectCase.vue?vue&type=script&lang=js&"
import style0 from "./projectCase.vue?vue&type=style&index=0&id=bd05d70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd05d70e",
  null
  
)

export default component.exports